import React, { useRef, useEffect, useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import * as _ from "lodash";
import "./tooltip.scss";

const OverflowTip = (props) => {
  const [hoverStatus, setHover] = useState(false);
  const textElementRef = useRef<HTMLInputElement | null>(null);

  const compareSize = () => {
    const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setHover(compare);
  };

  useEffect(() => {
    compareSize();
    window.addEventListener("resize", compareSize);
    return () => {
      window.removeEventListener("resize", compareSize);
    };
  }, [props]);

  return (
    <Tooltip
      title={props.text}
      interactive
      placement="top"
      arrow
      disableTouchListener
      disableFocusListener
      classes={{ tooltip: "tooltip" }}
      disableHoverListener={!hoverStatus}>
      <div
        ref={textElementRef}
        style={{
          maxWidth: _.get(props, "width", "90%"),
        }}
        className="text-div">
        {props.text}
      </div>
    </Tooltip>
  );
};

export default OverflowTip;
